import React from "react";
import { api } from "@/lib/admin/api";
import { PageHead } from "@/pages/admin/Layout";
import { TextInput, toast } from "@/components/admin/ui";

const FIELDS = [
  { id: "telegram",  label: "Telegram",  ph_url: "https://t.me/official2high",   ph_h: "@official2high", icon: "T" },
  { id: "instagram", label: "Instagram", ph_url: "https://instagram.com/2high",  ph_h: "@2high",         icon: "Ig" },
  { id: "tiktok",    label: "TikTok",    ph_url: "https://tiktok.com/@2high",    ph_h: "@2high",         icon: "Tk" },
  { id: "phone",     label: "Phone",     ph_url: "tel:+1234567890",              ph_h: "+1 (234) 567-890", icon: "☎" },
  { id: "email",     label: "Email",     ph_url: "mailto:hello@2high.co",        ph_h: "hello@2high.co", icon: "@" },
];

export default function Contact() {
  const [form, setForm] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [dirty, setDirty] = React.useState(false);

  React.useEffect(() => { api.getContent().then(setForm); }, []);
  if (!form) return <div className="text-[#6e6f5f] text-sm p-8">Loading…</div>;

  function patch(p) { setForm((f) => ({ ...f, ...p })); setDirty(true); }

  async function save() {
    setSaving(true);
    try {
      const payload = {};
      FIELDS.forEach((f) => {
        payload[`contact_${f.id}_url`] = form[`contact_${f.id}_url`] || "";
        payload[`contact_${f.id}_handle`] = form[`contact_${f.id}_handle`] || "";
      });
      const next = await api.saveContent(payload);
      setForm((f) => ({ ...f, ...next }));
      setDirty(false);
      toast("Contact links saved — live across the site");
    } catch (e) { toast(e.response?.data?.detail || "Save failed", "error"); }
    finally { setSaving(false); }
  }

  return (
    <div data-testid="contact-page" className="-mx-4 lg:-mx-8 -my-4 lg:-my-8 min-h-screen px-4 lg:px-8 py-4 lg:py-8 pb-32">
      <PageHead
        eye="CONTACT LINKS"
        title="Global Inquiry Channels"
        sub="Every Inquire / Telegram button on the public site uses these links. cms-bridge.js syncs them automatically."
      />

      <div className="rounded-2xl border border-[#22261b] bg-[#13150f] divide-y divide-[#22261b] max-w-5xl overflow-hidden">
        {FIELDS.map((f) => (
          <div key={f.id} className="grid grid-cols-1 md:grid-cols-[180px_1fr_1fr] gap-3 items-center px-5 py-4">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg grid place-items-center font-bold text-[14px]" style={{ background: "#231d10", color: "#c9a86b", border: "1px solid #c9a86b40" }}>{f.icon}</span>
              <div className="text-[11.5px] tracking-[.22em] uppercase text-[#e8e4d8]">{f.label}</div>
            </div>
            <div>
              <div className="text-[10px] tracking-[.16em] uppercase text-[#6e6f5f] mb-1.5">URL</div>
              <TextInput
                data-testid={`contact-${f.id}-url`}
                placeholder={f.ph_url}
                value={form[`contact_${f.id}_url`] || ""}
                onChange={(e) => patch({ [`contact_${f.id}_url`]: e.target.value })}
              />
            </div>
            <div>
              <div className="text-[10px] tracking-[.16em] uppercase text-[#6e6f5f] mb-1.5">Display handle</div>
              <TextInput
                data-testid={`contact-${f.id}-handle`}
                placeholder={f.ph_h}
                value={form[`contact_${f.id}_handle`] || ""}
                onChange={(e) => patch({ [`contact_${f.id}_handle`]: e.target.value })}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Sticky save bar */}
      <div className="fixed bottom-0 left-0 right-0 z-40 lg:left-[240px] px-5 py-3 bg-[#10120c]/95 backdrop-blur border-t border-[#22261b] flex items-center justify-between gap-3">
        <div className="text-[11px] font-mono tracking-[.06em] text-[#6e6f5f]">
          {dirty ? <span className="text-[#c9a86b]">● Unsaved changes</span> : <span className="text-[#5fa15a]">● All saved</span>}
        </div>
        <button
          data-testid="contact-save"
          onClick={save}
          disabled={saving || !dirty}
          className="px-5 py-2.5 rounded-md text-[12px] tracking-[.2em] uppercase font-bold disabled:opacity-50"
          style={{ background: "linear-gradient(180deg,#d4b675,#a07c39)", color: "#1a1407" }}
        >{saving ? "Saving…" : "Save Contact Links"}</button>
      </div>
    </div>
  );
}
